// extracted by mini-css-extract-plugin
export default {"toolbarRight":"ToolbarRight_toolbarRight__j6vhH"};